import React from 'react';
import { Box, Container, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { motion } from 'framer-motion';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';

const FAQ_ITEMS = [
  {
    question: 'Preciso ter CNPJ?',
    answer:
      'Os planos empresariais são voltados a quem possui CNPJ ou empresa constituída. Se você ainda não tem CNPJ, fale com a nossa equipe para entender as opções disponíveis para o seu caso.',
  },
  {
    question: 'Médicos podem contratar planos empresariais?',
    answer:
      'Sim. Médicos que atuam como Pessoa Jurídica, mesmo sozinhos, podem avaliar planos de saúde empresariais, geralmente com condições diferentes das dos planos individuais.',
  },
  {
    question: 'Posso incluir minha família?',
    answer:
      'Em muitos casos é possível incluir dependentes, como cônjuge e filhos. As regras variam conforme a operadora e o plano, e nossa equipe pode te ajudar a entender as opções compatíveis com o seu perfil.',
  },
  {
    question: 'Posso solicitar uma análise mesmo tendo outro plano?',
    answer:
      'Sim. Você pode solicitar uma análise das suas possibilidades mesmo já tendo um plano de saúde ativo, para comparar cobertura, rede e custo-benefício antes de decidir.',
  },
  {
    question: 'A MedPrime atende clínicas?',
    answer:
      'Sim. Atendemos clínicas e empresas da área da saúde que desejam avaliar planos e benefícios para sócios e colaboradores.',
  },
  {
    question: 'Como funciona a cotação?',
    answer:
      'Você preenche o formulário com algumas informações sobre seu perfil, nossa equipe analisa as opções disponíveis e retorna com uma proposta personalizada para você avaliar, sem custo e sem compromisso.',
  },
];

const FaqSection: React.FC = () => {
  return (
    <Box
      id="faq"
      component="section"
      sx={{ py: { xs: 8, md: 12 }, bgcolor: 'background.default', scrollMarginTop: { xs: 88, md: 100 } }}
    >
      <Container maxWidth="md">
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5 }}
          sx={{ textAlign: 'center', mb: 6 }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: '0.8rem',
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: 'secondary.dark',
              mb: 1.5,
            }}
          >
            Dúvidas frequentes
          </Typography>
          <Typography variant="h2" sx={{ fontSize: { xs: '1.75rem', md: '2.1rem' } }}>
            Perguntas frequentes
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {FAQ_ITEMS.map((item, index) => (
            <Accordion
              key={item.question}
              component={motion.div}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              disableGutters
              elevation={0}
              sx={{
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
                '&:before': { display: 'none' },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreRoundedIcon sx={{ color: 'primary.main' }} />}
                aria-controls={`faq-content-${index}`}
                id={`faq-header-${index}`}
                sx={{ px: 3, py: 0.5 }}
              >
                <Typography sx={{ fontWeight: 600 }}>{item.question}</Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ px: 3, pb: 2.5 }}>
                <Typography sx={{ color: 'text.secondary', lineHeight: 1.7 }}>{item.answer}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default FaqSection;
